import { QuestionTypes } from 'enum/questionTypes.enum'
import {
  IQuestionBankAnswer,
  IQuestionBankData,
  IQuestionBankQuestion,
  IQuestionBankSection,
} from 'interfaces/questionBank'
import { AiEvaluationQuestion } from 'api/administration/lessons/aiEvaluation'
import { getUntitledSectionName } from 'store/slices/initialData'

export interface AiEvaluationMappingMeta {
  name: string
  description: string
}

const SCORE_PER_QUESTION = 1

const buildQuestionCode = (position: number) =>
  `Q${String(position).padStart(3, '0')}`

const mapAnswers = (question: AiEvaluationQuestion): IQuestionBankAnswer[] =>
  [...question.options]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((option, index) => ({
      name: option.label,
      correct: !!option.correct,
      order: index,
    }))

const mapQuestion = (
  question: AiEvaluationQuestion,
  index: number
): IQuestionBankQuestion => ({
  name: question.name,
  code: buildQuestionCode(index + 1),
  score: SCORE_PER_QUESTION,
  order: index,
  multimediaContent: null,
  showAnswerExplanation: false,
  answerExplanation: '',
  type: QuestionTypes.likert,
  answers: mapAnswers(question),
})

// Convierte el preview generado por Rankmi IA a la forma del Banco de Preguntas v2
// para volcarlo en el editor manual (sin persistir). Solo trae las preguntas y el
// nombre/descripción sugeridos; el resto de la configuración (puntaje de aprobación,
// reintentos, etc.) queda en sus valores por defecto para que la persona la defina
// en el editor, igual que en el flujo sin IA.
export const aiPreviewToQuestionBank = (
  questions: AiEvaluationQuestion[],
  meta: AiEvaluationMappingMeta
): IQuestionBankData => {
  const mappedQuestions = questions.map(mapQuestion)

  const section: IQuestionBankSection = {
    name: getUntitledSectionName(),
    description: '',
    randomOrder: false,
    randomQuestionsToDisplay: mappedQuestions.length || 1,
    scoreForEachQuestion: SCORE_PER_QUESTION,
    order: 0,
    questions: mappedQuestions,
  }

  return {
    name: meta.name,
    description: meta.description,
    sections: [section],
    minimumPassingScore: 0,
    mandatory: false,
    approvalRequired: false,
    showResults: false,
    multipleRetries: false,
    maxRetries: 1,
  }
}
